import { MEASURE } from '@adtrackify/at-tracking-event-types';

import type { TableColumn } from '@/store/tables/types/table-columns-types';

export const DEFAULT_PNL_COLUMNS: TableColumn[] = [
  { id: 'orders_gross_revenue', measure: MEASURE.ORDERS_GROSS_REVENUE, label: 'Gross Revenue', visible: true, category: 'Revenue' },
  { id: 'orders_discount_amount', measure: MEASURE.ORDERS_DISCOUNT_AMOUNT, label: 'Discounts', visible: true, category: 'Revenue' },
  { id: 'orders_refund_amount', measure: MEASURE.ORDERS_REFUND_AMOUNT, label: 'Refunds', visible: true, category: 'Revenue' },
  { id: 'orders_net_revenue', measure: MEASURE.ORDERS_NET_REVENUE, label: 'Net Revenue', visible: true, category: 'Revenue' },
  { id: 'orders_cogs', measure: MEASURE.ORDERS_COGS, label: 'COGS', visible: true, category: 'Costs' },
  { id: 'orders_cm1', measure: MEASURE.ORDERS_CM1, label: 'CM1', visible: true, category: 'Margins' },
  { id: 'orders_handling_cost', measure: MEASURE.ORDERS_HANDLING_COST, label: 'Handling', visible: false, category: 'Costs' },
  { id: 'orders_gateway_cost', measure: MEASURE.ORDERS_GATEWAY_COST, label: 'Gateway Fees', visible: false, category: 'Costs' },
  { id: 'orders_shipping_cost', measure: MEASURE.ORDERS_SHIPPING_COST, label: 'Shipping', visible: false, category: 'Costs' },
  { id: 'orders_other_cost', measure: MEASURE.ORDERS_OTHER_COST, label: 'Other Costs', visible: false, category: 'Costs' },
  { id: 'orders_cm2', measure: MEASURE.ORDERS_CM2, label: 'CM2', visible: true, category: 'Margins' },
  { id: 'channel_spend', measure: MEASURE.CHANNEL_SPEND, label: 'Ad Spend', visible: true, category: 'Costs' },
  { id: 'orders_cm3', measure: MEASURE.ORDERS_CM3, label: 'CM3', visible: true, category: 'Margins' },
];

export const PNL_MEASURES: MEASURE[] = [
  MEASURE.ORDERS_GROSS_REVENUE,
  MEASURE.ORDERS_DISCOUNT_AMOUNT,
  MEASURE.ORDERS_REFUND_AMOUNT,
  MEASURE.ORDERS_NET_REVENUE,
  MEASURE.ORDERS_COGS,
  MEASURE.ORDERS_CM1,
  MEASURE.ORDERS_HANDLING_COST,
  MEASURE.ORDERS_GATEWAY_COST,
  MEASURE.ORDERS_SHIPPING_COST,
  MEASURE.ORDERS_OTHER_COST,
  MEASURE.ORDERS_CM2,
  MEASURE.CHANNEL_SPEND,
  MEASURE.ORDERS_CM3,
];
